<template><VisitList title="ویزیت‌های تأییدشده" status="3" detail-route="answerListCustomers" /></template>
<script>
import VisitList from './VisitList.vue';
export default { components: { VisitList } };
</script>
